var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtractMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 1.66597e-07 13.9706 1.07324e-07 9C4.80506e-08 4.02944 4.02944 1.66597e-07 9 1.07324e-07C13.9706 4.80506e-08 18 4.02944 18 9ZM5.00031 8.49945L5.50031 8.49945L11.2932 8.49945L9.6462 6.85249L9.29265 6.49894L9.99975 5.79183L10.3533 6.14539L12.8538 8.64589L13.2074 8.99944L12.8538 9.35299L10.3533 11.8535L9.99976 12.207L9.29265 11.4999L9.6462 11.1464L11.2931 9.49945L5.50031 9.49945L5.00031 9.49945L5.00031 8.49945Z",
    fill: "#097990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractMenu);
export default __webpack_public_path__ + "static/media/subtract-menu.ceb579f6b39efda6eef37cef04698859.svg";
export { ForwardRef as ReactComponent };